export const modalTypes = {
  SELECTED_TEAM_MODAL_OPEN: 'SELECTED_TEAM_MODAL_OPEN',
  SET_MODAL_ACTION: 'SET_MODAL_ACTION',
};
